import LocationOnRounded from '@mui/icons-material/LocationOnRounded';
import { Box, IconButton, SxProps, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { AssignmentStatus, TrackingNumberStatus, Workflow } from '@apiContract';
import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';
import isString from 'lodash/isString';

interface ILocationIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
}

const LocationIcon: FC<ILocationIconProps> = ({ onClick, capturePiece }) => {
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;

  const isLocker = piece?.workflow === Workflow.Lockers;

  const isLockerNotAssigned = isLocker && piece?.pieceSummary?.pieceAssignmentStatus !== AssignmentStatus.Assigned;

  const blockedByTrackingTracking =
    isLocker && piece?.pieceSummary?.trackingNumberStatus !== TrackingNumberStatus.Valid;

  const disabled =
    !piece || (isLockerNotAssigned && 'LockerNotAssigned') || (blockedByTrackingTracking && 'BlockedByTracking');

  return (
    <Tooltip title={tooltips[isString(disabled) ? disabled : 'LocationOnRounded']} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={!!disabled}
          aria-label={tooltips.LocationOnRounded}
          sx={{ ...CommonStyles, ...sxMR0 } as SxProps}
        >
          <LocationOnRounded sx={StyledIcon(disabled ? 'action.disabled' : undefined)} />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { LocationIcon };
